module.exports = __webpack_public_path__ + "static/media/star_in_yellow.695a0515.svg";